window.checkDropboxAuth = async (shopifyUserId) => {
  try {
    // Validate required parameter
    if (!shopifyUserId) {
      console.error("Shopify User ID is required for Dropbox auth check");
      return false;
    }

    // Make API request to check user authentication status
    const response = await fetch(
      `https://apps.shiftworship.com/api/dropbox/user-status?shopifyUserId=${encodeURIComponent(shopifyUserId)}`
    );

    // Check if request was successful
    if (!response.ok) {
      console.error("Failed to check Dropbox auth status:", response.status, response.statusText);
      return false;
    }

    // Parse response
    const data = await response.json();

    // Return authentication status
    return data.authenticated === true;
  } catch (error) {
    console.error("Error checking Dropbox authentication:", error);
    return false;
  }
};

window.triggerOauth = (shopifyUserId) => {
  try {
    // Validate required parameter
    if (!shopifyUserId) {
      console.error("Shopify User ID is required for Dropbox OAuth");
      return false;
    }

    // Trigger Dropbox auth popup or redirect
    const url = `https://apps.shiftworship.com/api/dropbox/auth?user=${encodeURIComponent(shopifyUserId)}`;
    const authWindow = window.open(url, "dropbox-auth", "width=600,height=600");

    if (!authWindow) {
      console.error("Failed to open Dropbox auth window. Please check popup blockers.");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error triggering Dropbox OAuth:", error);
    return false;
  }
};
